export const APP_NAME = "ENKRIP";
export const DEVICE_TYPE_DESKTOP = "desktop";